<template>
    <div>
        <Header />
        <div v-if="loading" class="product-detail-wrap" style="padding: 40px; text-align: center; color: #888;">
            加载中…
        </div>
        <div v-else class="product-detail-wrap">
            <div class="content">
                <p style="padding: 10px; line-height: 22px; margin-bottom: 0;"><span class="home"
                        @click="toHome">网站首页</span> <span style="color: #d9d9d9;">——</span> 未联系客服前勿拍本商品
                    【补差价专用链接】请根据客服沟通指引下单，请勿乱拍</p>

                <div class="detail-wrap">
                    <div style="display: flex;" class="mobile-wrap">
                        <div class="detail pc-right detail-left">
                            <div class="item mobile-wrap">
                                <div class="detail-img">
                                    <div class="gallery-frame">
                                        <a-carousel
                                            v-if="galleryImages.length > 1"
                                            arrows
                                            dots
                                            :autoplay="false"
                                            class="product-gallery"
                                        >
                                            <template #prevArrow>
                                                <div class="gallery-arrow gallery-arrow-left" aria-label="上一张">
                                                    <left-outlined />
                                                </div>
                                            </template>
                                            <template #nextArrow>
                                                <div class="gallery-arrow gallery-arrow-right" aria-label="下一张">
                                                    <right-outlined />
                                                </div>
                                            </template>
                                            <div v-for="(img, idx) in galleryImages" :key="idx" class="gallery-slide">
                                                <img :src="img" class="img" alt="" />
                                            </div>
                                        </a-carousel>
                                        <img
                                            v-else-if="galleryImages.length === 1"
                                            :src="galleryImages[0]"
                                            class="img"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div class="product-meta">
                                    <p class="product-title">{{ detail.title }}</p>
                                    <div class="product-desc">{{ detail.detail || '暂无描述' }}</div>

                                    <div style="margin-top: 20px; display: flex; align-items: center;">
                                        <span style="color:#666; margin-right: 8px;">购买数量：</span>
                                        <a-space :size="8">
                                            <div class="add-icon" v-if="inputNumber && Number(inputNumber) > 1"
                                                @click="inputNumber--">
                                                <minus-outlined />
                                            </div>
                                            <div class="add-icon" v-else style="cursor: not-allowed;">
                                                <minus-outlined />
                                            </div>
                                            <a-input v-model:value="inputNumber"
                                                onkeyup="this.value=this.value.replace(/\D/g,'')"
                                                onafterpaste="this.value=this.value.replace(/\D/g,'')"
                                                style="width: 80px;" :maxLength="6" />
                                            <div class="add-icon" @click="inputNumber++">
                                                <plus-outlined />
                                            </div>

                                        </a-space>
                                    </div>

                                    <div style="margin-top: 20px;">
                                        <p>请选择支付方式</p>
                                        <div
                                            style="background: #4096ff; height: 38px; border-radius: 4px; width: 170px; display: flex;align-items: center; justify-content: center;">
                                            <div>
                                                <img src="../assets/pay-way.png"
                                                    style="width: 20px;height: 20px;margin-right: 10px;">
                                                <span style="color: #fff;">USTD 网关支付</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="price-wrap pc-left detail-right">
                            <div>
                                <p style="color:#e7473c; font-weight: bold; margin-bottom: 0;font-size: 28px;">{{
                                    `$ ${detail.price}`
                                    }}
                                </p>
                                <p style="margin-top: 24px;">{{ accountFieldLabel }}</p>
                                <a-input v-model:value="inputGT" :placeholder="accountFieldPlaceholder"></a-input>
                                <p style="color:#666;margin-top: 16px;">游客购买后，查询订单信息需要用到 查单密码 。登录用户无需填写此项</p>

                                <div class="buy" @click="onBuy">
                                    <div>
                                        <img src="../assets/car.png"
                                            style="width: 20px;height: 20px;margin-right: 10px;">
                                        <span style="color: #fff;">立即购买</span>
                                    </div>
                                </div>

                                <p style="color:#888; margin-top: 20px;">销售信息</p>
                                <div class="sell-info">
                                    <div class="img">
                                        <img src="../assets/count.png">
                                    </div>
                                    <div class="item">
                                        <p>库存剩余</p>
                                        <span>{{ detail.count }}</span>
                                    </div>
                                </div>
                                <div class="sell-info">
                                    <div class="img">
                                        <img src="../assets/sell.png">
                                    </div>
                                    <div class="item">
                                        <p>总销量</p>
                                        <span>{{ detail.sell }}</span>
                                    </div>
                                </div>
                                <div class="sell-info">
                                    <div class="img">
                                        <img src="../assets/send-way.png">
                                    </div>
                                    <div class="item">
                                        <p>发货方式</p>
                                        <span>{{ detail.sendWay }}</span>
                                    </div>
                                </div>

                                <div class="contact">
                                    <img src="../assets/gift.png" class="img">
                                    <p>遇到任何问题，请及时联系网站客服</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>

import Header from './header.vue';
import Footer from './footer.vue'
import { message } from 'ant-design-vue';
import { addOrder } from '../util/api';
import { loadProductForDetail } from '../util/productDetail';
import { attachGameGroupId } from '../util/deeplink';
import { pushSelectWallet } from '../util/paymentFlow';

export default {
    name: 'productDetail',
    props: {
        msg: String
    },
    components: {
        Header,
        Footer
    },
    data() {
        return {
            detail: {},
            referralCode: '',
            gameGroupId: '',
            inputNumber: 1,
            inputGT: '',
            loading: true,
        }
    },
    watch: {
        '$route.fullPath'() {
            this.fetchDetail();
        },
    },
    computed: {
        /** 通过 link_key 进入详情页（展示联系方式，字段仍为 inputGT） */
        isLinkKeyEntry() {
            return !!(this.$route.query?.link_key || this.detail?.link_key);
        },
        accountFieldLabel() {
            return this.isLinkKeyEntry ? '联系方式' : '联系方式';
        },
        accountFieldPlaceholder() {
            return this.isLinkKeyEntry
                ? '请输入 联系方式'
                : '请输入 联系方式';
        },
        galleryImages() {
            const list = Array.isArray(this.detail?.images) ? this.detail.images.filter(Boolean) : [];
            if (list.length) return list;
            return this.detail?.src ? [this.detail.src] : [];
        },
    },
    mounted() {
        this.fetchDetail();
    },
    methods: {
        async fetchDetail() {
            this.loading = true;
            try {
                const { detail, referralCode, gameGroupId } = await loadProductForDetail(this.$route);
                this.detail = detail;
                this.referralCode = referralCode;
                this.gameGroupId = gameGroupId || '';
            } catch (e) {
                console.warn('[Detail] 加载商品失败', e);
                message.error('商品加载失败');
                this.$router.replace('/');
            } finally {
                this.loading = false;
            }
        },
        async onBuy() {
            if (!this.inputGT) {
                // message.warning(
                //     this.isLinkKeyEntry ? '请填写联系方式' : '请输入充值账号'
                // );
                // return
                this.inputGT = '';
            }
            // alert('购买数量:' + this.inputNumber + ';' + '价格：' + (this.detail.price * this.inputNumber))
            const data = {
                ...this.detail,
                src: '',
                inputNumber: this.inputNumber,
                inputGT: this.inputGT,
                referral_code: this.referralCode,
                orderNo: this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0'),
            };

            await addOrder(attachGameGroupId(data, this.gameGroupId));
            pushSelectWallet(this.$router, data, this.gameGroupId);
        },
        toHome() {
            this.$router.push('/');
        },
        getCurrentDateTime() {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }
    }
}
</script>

<style scoped lang="less">
.product-detail-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #f8f8f8;
}

.content {
    width: 1200px;

    .home {
        cursor: pointer;
    }

    .home:hover {
        color: #4096ff;
    }

    .detail-wrap {
        margin-top: 16px;
        border-radius: 4px;

        .detail {
            margin-top: 20px;

            .add-icon {
                width: 28px;
                height: 28px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #d9d9d9;
                border-radius: 2px;
            }

            .item {
                background: #fff;
                padding: 20px;
                display: flex;
                border-radius: 4px;
                box-shadow: 4px 4px 9px rgba(159, 186, 220, 0.2);
                cursor: pointer;

                .img {
                    width: 100%;
                    height: 100%;
                    margin-right: 32px;
                }

                .gallery-slide .img,
                .detail-img > .img {
                    margin-right: 0;
                }
            }

            .product-meta {
                flex: 1;
                min-width: 0;
                text-align: left;
            }

            .product-title {
                font-weight: bold;
                font-size: 20px;
                margin: 20px 0 0;
                text-align: left;
            }

            .product-desc {
                margin-top: 12px;
                font-size: 14px;
                line-height: 1.7;
                color: #666;
                text-align: left;
                white-space: pre-wrap;
                word-break: break-word;
            }
        }

        .price-wrap {
            margin: 20px 0;
            border-radius: 4px;
            background: #fff;
            padding: 20px;

            .buy {
                background: #444c69;
                height: 52px;
                width: 100%;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .sell-info {
                display: flex;
                margin-bottom: 16px;

                .img {
                    margin-right: 16px;
                    width: 34px;
                    height: 34px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f8f8f8;
                    border-radius: 4px;

                    img {
                        width: 16px;
                        height: 16px;
                    }
                }

                .item {
                    font-size: 13px;

                    p {
                        margin-bottom: 4px;
                    }

                    span {
                        color: #666;
                    }
                }
            }

            .contact {
                width: 100%;
                padding: 16px;
                background: #e1ebff;
                border-radius: 4px;
                display: flex;

                p {
                    margin-bottom: 0;
                }

                .img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }

                p {
                    line-height: 22px;
                }
            }
        }

    }
}

// 适配移动端
.mobile-hidden {
    display: block;
}

.mobile-wrap {
    flex-wrap: nowrap;
}

.pc-hidden {
    display: none;
}

.pc-right {
    margin-right: 10px;
}

.pc-left {
    margin-left: 10px;
}

.detail-left {
    flex: 75% 0;
}

.detail-img {
    flex: 33% 0;
    margin-right: 20px;
    min-width: 0;
    width: 100%;
    max-width: 420px;
}

.product-gallery {
    width: 100%;
}

/* 固定画幅，避免多图高度不一致导致轮播跳动 */
.gallery-frame {
    width: 100%;
    height: 360px;
    background: #f5f7fa;
    border-radius: 4px;
    overflow: hidden;
}

.gallery-slide {
    height: 360px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.gallery-slide .img,
.detail-img > .img,
.item .detail-img .gallery-slide .img,
.item .detail-img > .img {
    width: 100%;
    height: 360px;
    max-height: 360px;
    object-fit: contain;
    object-position: center;
    display: block;
    margin: 0 auto;
    margin-right: 0;
}

:deep(.product-gallery .slick-slider),
:deep(.product-gallery .slick-list),
:deep(.product-gallery .slick-track) {
    height: 360px;
}

:deep(.product-gallery .slick-slide) {
    height: 360px;
    text-align: center;
}

:deep(.product-gallery .slick-slide > div) {
    height: 100%;
}

.gallery-arrow {
    width: 32px;
    height: 32px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
    color: #fff;
    border-radius: 50%;
    z-index: 2;
}

.gallery-arrow-left {
    left: 8px;
}

.gallery-arrow-right {
    right: 8px;
}

:deep(.product-gallery .slick-dots) {
    bottom: 8px;
}

:deep(.product-gallery .slick-dots li button) {
    background: #bbb;
}

:deep(.product-gallery .slick-dots li.slick-active button) {
    background: #4096ff;
}

.detail-right {
    flex: 0 25%;
}

@media (max-width: 560px) {
    .content {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        padding: 0 12px;
    }

    .mobile-hidden {
        display: none;
    }

    .mobile-wrap {
        flex-wrap: wrap;
        flex-direction: column;
        align-items: stretch;
    }

    .content .detail-wrap .detail .item.mobile-wrap {
        flex-direction: column;
        align-items: stretch;
    }

    .pc-hidden {
        display: block;
    }

    .pc-right {
        margin-right: 0;
    }

    .pc-left {
        margin-left: 0;
    }

    .detail-left {
        flex: 0 0 100%;
        width: 100%;
        max-width: 100%;
    }

    .detail-img {
        flex: 0 0 auto;
        width: 100%;
        max-width: 100%;
        margin-right: 0;
    }

    .content .detail-wrap .detail .product-meta {
        flex: none;
        width: 100%;
        min-width: 0;
        margin-top: 4px;
    }

    .content .detail-wrap .detail .product-title {
        margin-top: 12px;
        font-size: 18px;
        word-break: break-word;
    }

    .content .detail-wrap .detail .product-desc {
        width: 100%;
    }

    .gallery-frame,
    .gallery-slide,
    .gallery-slide .img,
    .detail-img > .img,
    .item .detail-img .gallery-slide .img,
    .item .detail-img > .img,
    :deep(.product-gallery .slick-slider),
    :deep(.product-gallery .slick-list),
    :deep(.product-gallery .slick-track),
    :deep(.product-gallery .slick-slide) {
        height: 280px;
        max-height: 280px;
    }

    .detail-right {
        flex: 0 0 100%;
        width: 100%;
        max-width: 100%;
    }

    .content .detail-wrap .price-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
